import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'natural-orderby';
import { PadContainer, HorizontalFlex } from 'smartsuite-ui';
import { postDataPromise } from 'brock-fetch-utils';
import DashboardContext from '../../shared/hooks/dashboardContext';
import { useLabelContext } from '../../shared/hooks/labelContext';
import WidgetLoading from '../../shared/WidgetLoading';
import WidgetErrorMessage from '../../viewDashboards/widgets/WidgetErrorMessage';

function hydrateLinks(link, openLinksInNewTab, getNonApiUri) {
    return {
        displayText: link.displayText,
        icon: link.icon,
        target: openLinksInNewTab ? '_blank' : '',
        uri: link.isAbsoluteUri ? link.path : getNonApiUri(link.path),
        sortOrder: link.sortOrder,
    };
}

/* eslint-disable complexity */
function SystemLinks(props) {
    const { dashboardLabels } = useLabelContext();
    const { uriConstants } = useContext(DashboardContext);

    const [errorMessage, setErrorMessage] = useState(null);
    const [systemLinks, setSystemLinks] = useState(null);

    useEffect(() => {
        postDataPromise(uriConstants.getSystemLinks, {
            method: 'getSystemLinks',
        }).then(setSystemLinks, () =>
            setErrorMessage(dashboardLabels.systemLinksUnavailable)
        );
    }, [dashboardLabels.systemLinksUnavailable, uriConstants.getSystemLinks]);

    if (errorMessage) {
        return <WidgetErrorMessage>{errorMessage}</WidgetErrorMessage>;
    }

    if (!systemLinks) {
        return <WidgetLoading />;
    }

    if (!systemLinks.length) {
        return (
            <WidgetErrorMessage>
                {dashboardLabels.missingData}
            </WidgetErrorMessage>
        );
    }

    const linksWithFullUri = orderBy(
        systemLinks.map((link) =>
            hydrateLinks(
                link,
                props.openLinksInNewTab,
                uriConstants.getNonApiUri
            )
        ),
        ['sortOrder', 'displayText']
    );

    return (
        <PadContainer cssClassModifiers={['pad-small', 'no-pad-top']}>
            {linksWithFullUri.map((link) => (
                <PadContainer
                    key={link.displayText}
                    cssClassModifiers={['pad-medium', 'no-pad-top']}
                >
                    <HorizontalFlex>
                        {link.icon && (
                            <PadContainer
                                cssClassModifiers={[
                                    'pad-medium',
                                    'no-pad-top-bottom',
                                    'no-pad-left',
                                ]}
                            >
                                <span className={link.icon} />
                            </PadContainer>
                        )}
                        <a href={link.uri} target={link.target}>
                            {link.displayText}
                        </a>
                    </HorizontalFlex>
                </PadContainer>
            ))}
        </PadContainer>
    );
}
/* eslint-enable complexity */

SystemLinks.propTypes = {
    openLinksInNewTab: PropTypes.bool.isRequired,
};

export default SystemLinks;
